<template>
  <div>
    <div class="row1">
		<div>
			<el-button @click="onAdd" class="row-btn add" type="primary" size="small">增加</el-button>
		</div>
    </div>
    <div class="tab-box">
      <el-table
		 v-loading="loading"
         :data="tableData"
         style="width: 100%;margin-bottom: 20px;"
         row-key="id"
         default-expand-all
         :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
         <el-table-column
           prop="name"
           label="周边">
         </el-table-column>
		 <el-table-column width="400" label="操作" align="center">
			 <template slot-scope="scope">
				<div class="handle-box">
					<!-- <span class="txt-btn txtC" @click="handleAdd(scope.row)">添加下级</span> -->
					<span class="txt-btn txtC" @click="handleEdit(scope.row)">修改</span>
					<span class="txt-btn del-txt" @click="handleDel(scope.row)">删除</span>
				</div>
			</template>
		 </el-table-column>
       </el-table>
      
    </div>
	<!-- 添加弹框 -->
	<periphery :title="title" 
	:arr="peripheryArr" 
	:disabled="disabled" 
	@onPeriphery="onPeriphery"
	ref="detailDialog"></periphery>
	<!-- <offer-more :tableData="moreTabData" ref="moreDialog"></offer-more> -->
  </div>
</template>

<script>
	import periphery from "../../components/dialog/periphery.vue";
export default {
	components: {
	  periphery,
	},
  data() {
    return {
		id:'',
		disabled:false,
		title:'',
		peripheryArr:[],
		moreTabData:[],
      tableData: [],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {}
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      searchVal: "", //搜索框值
    };
  },
  created() {
    this.getList();
  },
  methods: {
	  // 修改/添加
	  onPeriphery(e){
		  console.log(e);
		  if(this.disabled){
			  // 修改
			  this.$api2.editPeriphery(e).then((res)=>{
				  if(res.code == 1){
					  this.$message.success(res.msg)
					  this.$refs.detailDialog.dialogVisible = false;
					  this.getList()
				  }else{
					  this.$message.error(res.msg)
				  }
			  })
		  }else{
			  // 添加
			  delete e.id
			  this.$api2.addPeriphery(e).then((res)=>{
				  if(res.code == 1){
					  this.$message.success(res.msg)
					  this.$refs.detailDialog.dialogVisible = false;
					  this.getList()
				  }else{
					  this.$message.error(res.msg)
				  }
			  })
		  }
		  console.log(e);
	  },
	  // 打开添加弹框
	  onAdd(){
		  for(let key in this.$refs.detailDialog.ruleForm){
		  	this.$refs.detailDialog.ruleForm[key] = ""
		  }
		  this.disabled = false;
		  this.$refs.detailDialog.dialogVisible = true;
	  },
	  //打开修改弹框
	  handleEdit(v){
		  this.$refs.detailDialog.ruleForm = {
			  id:v.id,
			  pid:v.pid,
			  name:v.name
		  }
		  this.disabled = true;
		  this.$refs.detailDialog.dialogVisible = true;
	  },
	  //删除
	  handleDel (v){
		  let str = ''
		  if(v.children){
			  str = '确认删除：'+v.name+' ？( 删除该父级及其所有子级 )'
		  }else{
			  str = '确认删除：'+v.name+' ？'
		  }
		  this.$confirm(str, '提示').then(() => {
			  this.$api2.deletePeriphery({id:v.id}).then((res)=>{
				  if(res.code == 1){
					  this.getList()
					  this.$message.success(res.msg)
				  }else{
					  this.$message.error(res.msg)
				  }
			  })
		  }).catch(()=>{})
	  },
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.peripheryTree(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
      		this.total = res.count;
      		this.tableData = res.data;
			this.peripheryArr = []
			res.data.forEach((v,k)=>{
				this.peripheryArr[k] = {
					pid:v.id,
					name:v.name,
					title:v.name
				}
			})
			this.peripheryArr.unshift({pid:0,title:'顶级（一级周边）'})
			console.log(this.peripheryArr);
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/public.scss";
.row1 {
  align-items: center;
  justify-content: space-between;
}
.search {
  margin-left: 10px;
  margin-right: 0 !important;
}
.handle-box {
    display: flex;
    justify-content: space-around;
}
</style>